import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ContentSet} from 'common/src/modules/contentSets/contentSets.types';

interface ContentFeedContentSetsState {
  items: ContentSet[];
  activeContentSet: ContentSet | null;
  isLoading: boolean;
}

const contentFeedContentSetsInitialState: ContentFeedContentSetsState = {
  items: [],
  activeContentSet: null,
  isLoading: false,
};

const contentFeedContentSetsSlice = createSlice({
  name: 'contentSets',
  initialState: contentFeedContentSetsInitialState,
  reducers: {
    setContentSetsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setContentSets: (state, action: PayloadAction<ContentSet[]>) => {
      state.items = action.payload;
    },
    removeContentSet: (state, action: PayloadAction<number>) => {
      state.items = state.items.filter((contentSet) => contentSet.id !== action.payload);

      // Clear activeContentSet if it's the one being removed
      if (state.activeContentSet?.id === action.payload) {
        state.activeContentSet = null;
      }
    },
    setActiveContentSet: (state, action: PayloadAction<ContentSet | null>) => {
      state.activeContentSet = action.payload;
    },

    resetContentSets: () => contentFeedContentSetsInitialState,
  },
});

export default contentFeedContentSetsSlice.reducer;

export const {
  setContentSetsLoading,
  setContentSets,
  removeContentSet,
  setActiveContentSet,
  resetContentSets,
} = contentFeedContentSetsSlice.actions;
